import { useMutation, useQuery } from "@apollo/client";
import { Col, Empty, Rate, Row, Spin } from "antd";
import { motion } from "framer-motion";
import GoogleMapReact from "google-map-react";
import React from "react";
import { Progress } from "antd";
import { useLocation } from "react-router-dom";
import {
  componentTransition,
  componentTransitionProp,
} from "../../animation/index";
import {
  GET_SERVICES_COMMENTS,
  MAKE_COMMENT,
  REPLY_COMMENT,
  REQUEST_TO_CHAT,
  RATE_SERVICE,
} from "../../app/apollo/index";
import { useAppSelector } from "../../app/hooks";
import { LoggerButton } from "../../globalComponents/Button";
import { Back, SmallMapContainer } from "../../globalComponents/globalStyle";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { ClusterContainer } from "../Locate/Style";
import { StyledInput } from "../Post/style";
import {
  CommentContainer,
  DetailsCard,
  IDAvatar,
  Rating,
  RequestResponse,
  SubmitButton,
  UserImage,
} from "./Styles";

const Details = () => {
  const location: any = useLocation();
  const userState = useAppSelector((state) => state?.userInfoReducer?.content);
  console.log("user info", userState);
  const [loadingState, setLoadingState] = React.useState(false);
  const [loadingComment, setCommentLoading] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const [loadingReply, setLoadingReply] = React.useState(false);
  const [commentReply, setCommentReply] = React.useState("");
  const [value, setValue] = React.useState(4);
  const [makeComment] = useMutation(MAKE_COMMENT);
  const [replyComment] = useMutation(REPLY_COMMENT);
  const [rateService] = useMutation(RATE_SERVICE);
  const { data, loading, error } = useQuery(GET_SERVICES_COMMENTS, {
    variables: {
      service_id: +location?.state?.service?.id,
      itemsPerPage: 100,
    },
  });

  const handleReplyComment = async (aReply: string, aCommentId: number) => {
    setLoadingReply(true);
    if (aReply.length > 0) {
      try {
        const response = await replyComment({
          variables: {
            comment_id: +aCommentId,
            reply: aReply,
          },
          // refetchQueries: [{ query: GET_SERVICES_COMMENTS }],
        });
        if (response) {
          setLoadingReply(false);
          if (response?.data?.replyComment?.status) {
            NotificationAlert("success", "Comment successful");
          } else {
            NotificationAlert(
              "success",
              "Error Occured",
              response?.data?.replyComment?.msg
            );
          }
        }
      } catch (e) {
        setLoadingReply(false);
        NotificationAlert("error", "Error Occured");
        console.log(error);
      }
    }
  };

  const handleMakeComment = async (aComment: string, aServiceId: number) => {
    setCommentLoading(true);
    if (aComment.length > 0) {
      try {
        const response = await makeComment({
          variables: {
            service_id: +aServiceId,
            comment: aComment,
          },
          // refetchQueries: [{ query: GET_SERVICES_COMMENTS }],
        });
        if (response) {
          setCommentLoading(false);
          if (response?.data?.makeComment?.status) {
            NotificationAlert("success", "Comment successful");
          } else {
            NotificationAlert(
              "success",
              "Error Occured",
              response?.data?.makeComment?.msg
            );
          }
        }
      } catch (e) {
        setCommentLoading(false);
        NotificationAlert("error", "Error Occured");
        console.log(error);
      }
    }
  };

  console.log("data", data);
  console.log("loading", loading);
  console.log("error", error);
  let commentList = data?.getServiceComments?.comments?.map((comment: any) => (
    <>
      <CommentContainer>
        {comment?.user?.photolink ? (
          <UserImage
            alt={comment?.user?.firstname}
            src={comment?.user?.photolink}
          />
        ) : (
          <IDAvatar>{comment?.user?.firstname.charAt(0) || ""}</IDAvatar>
        )}
        <div>
          <small>
            {comment?.user?.firstname} {comment?.user?.lastname}{" "}
            <span>{comment?.created_at.split(" ")[0]}</span>
          </small>
          <p>{comment?.comment}</p>
        </div>
      </CommentContainer>
      <div style={{ display: "block", width: "100%", paddingLeft: "50px" }}>
        <StyledInput
          onChange={(e) => {
            setCommentReply(e.target.value);
          }}
          onKeyDown={(e) => {
            e.keyCode === 13 && handleReplyComment(commentReply, comment.id);
          }}
          placeholder="reply to comment here..."
          autoSize={{ minRows: 1, maxRows: 1 }}
        />
        {loadingReply ? (
          <Spin />
        ) : (
          <SubmitButton
            onClick={() => handleReplyComment(commentReply, comment.id)}
          >
            reply
          </SubmitButton>
        )}
      </div>

      {comment?.replies.map((reply: any) => (
        <CommentContainer style={{ padding: "10px 0 20px 50px" }}>
          {/* <IDAvatar>{reply?.user?.firstname.charAt(0) || ""}</IDAvatar> */}
          <div>
            <small>
              {reply?.user?.firstname} {reply?.user?.lastname}{" "}
              <span>{reply.created_at.split(" ")[0]}</span>
            </small>
            <p>{reply?.reply}</p>
          </div>
        </CommentContainer>
      ))}
    </>
  ));

  const rateResult = (
    <div style={{ width: 170 }}>
      <span>
        <Progress percent={30} size="small" children={{}} /> 1
      </span>
      <Progress percent={50} size="small" />
      <Progress percent={70} size="small" />
      <Progress percent={99} size="small" />
      <Progress percent={99} size="small" />
    </div>
  );

  const handleRatingChange = async (values: number) => {
    setValue(values);
    try {
      const response = await rateService({
        variables: {
          rating: +values,
          service_id: +location?.state?.service?.id,
        },
      });
      if (response) {
        if (response?.data?.rateService?.status) {
          NotificationAlert("success", response?.data?.rateService?.msg);
        } else if (!response?.data?.rateService?.status) {
          NotificationAlert(
            "error",
            "Error Occured",
            response?.data?.rateService?.msg
          );
        }
      }
    } catch (e) {
      NotificationAlert("error", "Error Occured");
      console.log("handle rating", e);
    }
  };
  console.log("the state is", location?.state?.service);
  const [requestToChatWithUser] = useMutation(REQUEST_TO_CHAT);
  const desc = ["terrible", "bad", "normal", "good", "wonderful"];
  const requestChat = async (id: number, message: String) => {
    setLoadingState(true);
    try {
      const response = await requestToChatWithUser({
        variables: {
          user_id: id,
          msg: message,
        },
      });
      if (response) {
        setLoadingState(false);
        if (response?.data?.requestToChatWithUser?.success) {
          NotificationAlert(
            "success",
            "Success",
            response?.data?.requestToChatWithUser?.msg
          );
        } else {
          NotificationAlert(
            "error",
            "Error",
            response?.data?.requestToChatWithUser?.msg
          );
        }
      }
    } catch (e) {
      setLoadingState(false);
      NotificationAlert(
        "error",
        "Error occured",
        "Could not request.Try Again."
      );
    }
  };
  const Marker: React.FC<any> = ({ children }) => (
    <div
      style={{
        padding: "1px",
        color: "white",
      }}
    >
      {children}
    </div>
  );
  return (
    <motion.div
      variants={componentTransition}
      initial="initial"
      animate="in"
      exit="out"
      transition={componentTransitionProp}
    >
      <Back />
      <SmallMapContainer>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_KEY as string }}
          defaultCenter={{
            lat: Number(location?.state?.service?.location[0]?.lat),
            lng: Number(location?.state?.service?.location[0]?.lng),
          }}
          defaultZoom={20}
          yesIWantToUseGoogleMapApiInternals
        >
          <Marker
            lat={Number(location?.state?.service?.location[0]?.lat)}
            lng={Number(location?.state?.service?.location[0]?.lng)}
          >
            <ClusterContainer>location</ClusterContainer>
          </Marker>
        </GoogleMapReact>
      </SmallMapContainer>
      <br />
      <Row justify="space-between">
        <Col xs={{ span: 24 }} md={{ span: 11 }}>
          <DetailsCard>
            <h2>Service Provider Basic Details</h2>
            <h3>
              Business Name:{location?.state?.service?.name || "Not Available"}
            </h3>
            <h3>
              Country:{" "}
              {location?.state?.service?.countries[0] || "Not Available"}
            </h3>
            <h3>
              State/City: {location?.state?.service?.cities || "Not Available"}
            </h3>
            <h3>
              Description:{" "}
              {location?.state?.service?.details || "Not Available"}
            </h3>
          </DetailsCard>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 12 }}>
          <DetailsCard>
            <h2>Contact Information</h2>
            <h3>
              {" "}
              Email: {location?.state?.service?.email || "Not Available"}
            </h3>
            <h3>
              Mobile number:{" "}
              {location?.state?.service?.mobile || "Not Available"}
            </h3>
            <h3>
              Business address:{" "}
              {location?.state?.service?.location[0]?.locationName}
            </h3>
            {location?.state?.service?.owner?.canRequestToChat && (
              <LoggerButton
                onClick={() => {
                  requestChat(
                    location?.state?.service?.user_id,
                    "Hey good day, I would like to mke use of your service.Thank you!"
                  );
                }}
                loading={loadingState}
                text="Send Message Request"
              />
            )}
            {location?.state?.service?.owner?.requestToChatStatus && (
              <RequestResponse>
                Your request response:{" "}
                <span>
                  {location?.state?.service?.owner?.requestToChatStatus}
                </span>
              </RequestResponse>
            )}
          </DetailsCard>
        </Col>
      </Row>

      <DetailsCard style={{ width: "100%" }}>
        <Row>
          <Col xs={{ span: 24 }} md={{ span: 4 }}>
            <Rating>Rate Service</Rating>
            <span>
              <Rate
                tooltips={desc}
                onChange={handleRatingChange}
                value={value}
              />
              {value ? (
                <span className="ant-rate-text">{desc[value - 1]}</span>
              ) : (
                ""
              )}
            </span>
            {/* {rateResult} */}
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 19, offset: 1 }}>
            <Rating>Make Comment</Rating>
            <div style={{ display: "flex", width: "100%" }}>
              <div>
                {userState?.photolink ? (
                  <UserImage
                    alt={userState?.firstname}
                    src={userState?.photolink}
                  />
                ) : (
                  <IDAvatar>{userState?.firstname.charAt(0) || ""}</IDAvatar>
                )}
              </div>
              <div style={{ display: "block", width: "100%" }}>
                <StyledInput
                  onChange={(e) => {
                    setComment(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    e.keyCode === 13 &&
                      handleMakeComment(comment, +location?.state?.service?.id);
                  }}
                  placeholder="Type your comment here..."
                  autoSize={{ minRows: 2, maxRows: 3 }}
                />
                {loadingComment ? (
                  <Spin />
                ) : (
                  <SubmitButton
                    onClick={() =>
                      handleMakeComment(comment, +location?.state?.service?.id)
                    }
                  >
                    Submit review
                  </SubmitButton>
                )}
              </div>
            </div>
            <br />
            <Rating>Comments</Rating>
            <br />
            {commentList}
            {data?.getServiceComments?.comments?.length < 1 && <Empty />}
          </Col>
        </Row>
      </DetailsCard>
    </motion.div>
  );
};

export default Details;
